import PlanRoot from "./plan";
import Body from "./slots/body";
import Banner from "./slots/banner";
import Heading from "./slots/heading";
import Grid from "./slots/grid";
import Item from "./slots/item";
import Purchase from "./slots/purchase";

const PlanUI = Object.assign(PlanRoot, {
  Grid,
  Heading,
  Item,
  Purchase,
  Banner,
  Body,
});


export default PlanUI
